<!-- 企信转单操作模块-转化成销售单 -->
<template>
    <div class="business-content-main sales-order-edit" v-loading="searchApParams._visible" element-loading-spinner="none">
        <div>
            <div class="bread-nav">
                <breadcrumb :canBackHistory="true" :pageTitle="pageTitle"></breadcrumb>
            </div>
            <!--   form     -->
            <div class="section-title" @click="showMsg">
                <div>
                    <span>订单信息</span>&nbsp;&nbsp;&nbsp;&nbsp;
                    <span v-if="!showOrderMsg && submitData.EntpCusName">客户：{{ submitData.EntpCusName }}</span>
                </div>
            </div>
            <div class="open-icon" @click="showMsg" v-if="!showOrderMsg">
                <img src="../../../assets/images/open-msg.png" />
            </div>
            <div class="search-ctn" v-show="showOrderMsg">
                <el-form :model="submitData" ref="formMsg" label-width="100px" style="width: 100%; padding-right: 30px; padding-left: 30px" :rules="rules">
                    <el-row :gutter="20">
                        <el-col :span="5">
                            <div class="grid-content bg-purple">
                                <el-form-item label="客户" prop="EntpCusId">
                                    <el-input disabled v-model.trim="submitData.EntpCusName"></el-input>
                                </el-form-item>
                            </div>
                        </el-col>
                        <el-col :span="5">
                            <div class="grid-content bg-purple">
                                <el-form-item label="业务员" prop="SId">
                                    <el-select
                                        v-model="submitData.SId"
                                        :disabled="dataReadonly"
                                        filterable
                                        clearable
                                        placeholder="请选择"
                                        @change="sIdChange($event)"
                                        @visible-change="siVisibleChange($event)"
                                        style="width: 100%"
                                    >
                                        <el-option v-for="item in SIdList" :key="item.EmployeeId" :label="item.EmployeeName" :value="item.EmployeeId"></el-option>
                                    </el-select>
                                </el-form-item>
                            </div>
                        </el-col>
                        <el-col :span="5">
                            <div class="grid-content bg-purple">
                                <el-form-item label="联系电话" prop="PhoneNum">
                                    <el-input v-model.trim="submitData.PhoneNum"></el-input>
                                </el-form-item>
                            </div>
                        </el-col>
                        <el-col :span="5">
                            <div class="grid-content bg-purple">
                                <el-form-item label="发货方式" prop="ShipType">
                                    <el-select v-model="submitData.ShipType" :disabled="dataReadonly" placeholder="请选择" style="width: 100%">
                                        <el-option v-for="item in DeliveryMethodList" :key="item.Value" :label="item.Text" :value="item.Value"></el-option>
                                    </el-select>
                                </el-form-item>
                            </div>
                        </el-col>
                        <el-col :span="4">
                            <div class="grid-content bg-purple">
                                <el-form-item label="运输费用" prop="ShipAmount">
                                    <el-input min="0" type="number" step="0.01" v-model.trim="submitData.ShipAmount" @change="resetHeight"></el-input>
                                </el-form-item>
                            </div>
                        </el-col>
                    </el-row>
                    <el-row :gutter="20">
                        <el-col :span="5">
                            <div class="grid-content bg-purple">
                                <el-form-item label="结算方式" prop="PayType">
                                    <el-select v-model="submitData.PayType" placeholder="请选择" style="width: 100%">
                                        <el-option v-for="item in payWayList" :key="item.Value" :label="item.Text" :value="item.Value"></el-option>
                                    </el-select>
                                </el-form-item>
                            </div>
                        </el-col>
                        <el-col :span="5">
                            <div class="grid-content bg-purple">
                                <el-form-item label="出仓仓库" prop="WarehouseId">
                                    <el-select
                                        v-model="submitData.WarehouseId"
                                        placeholder="请选择"
                                        style="width: 100%"
                                        filterable
                                        clearable
                                        @visible-change="warehouseVisibleChange($event)"
                                        @change="warehouseChange"
                                    >
                                        <el-option
                                            v-for="optionItem in warehouseList"
                                            :key="optionItem.WarehouseId"
                                            :label="optionItem.WarehouseName"
                                            :value="optionItem.WarehouseId"
                                            ><span style="float: left">{{ optionItem.WarehouseName }}</span>
                                            <span v-if="optionItem.Type == 1" style="float: right; color: #8492a6; font-size: 13px">（前置仓）</span></el-option
                                        >
                                    </el-select>
                                </el-form-item>
                            </div>
                        </el-col>
                        <el-col :span="5" v-if="funcConfig">
                            <div class="grid-content bg-purple">
                                <el-form-item label="跟单采购员" prop="FollowerId">
                                    <el-select
                                        v-model="submitData.FollowerId"
                                        filterable
                                        clearable
                                        placeholder="请选择"
                                        @change="followerChange($event)"
                                        @visible-change="siVisibleChange($event)"
                                        style="width: 100%"
                                    >
                                        <el-option v-for="item in FollowerList" :key="item.EmployeeId" :label="item.EmployeeName" :value="item.EmployeeId"></el-option>
                                    </el-select>
                                </el-form-item>
                            </div>
                        </el-col>
                        <el-col :span="5">
                            <div class="grid-content bg-purple">
                                <el-form-item label="物流公司" prop="">
                                    <el-input
                                        v-if="dataReadonly"
                                        :title="submitData.LogisticName"
                                        v-model="submitData.LogisticName"
                                        style="width: 100%"
                                        :disabled="true"
                                    ></el-input>
                                    <el-select
                                        v-else
                                        style="width: 100%"
                                        v-model="submitData.LogisticItem"
                                        value-key="EntpCusId"
                                        placeholder="请输入物流公司"
                                        filterable
                                        clearable
                                        allow-create
                                        default-first-option
                                        remote
                                        reserve-keyword
                                        :remote-method="searchLogistic"
                                        @visible-change="logisticVisibleChange($event)"
                                        @change="logisticChange"
                                    >
                                        <el-option v-for="item in logisticsList" :key="item.EntpCusId" :data-msg="item" :label="item.EntpCusName" :value="item">
                                            <div class="name">
                                                {{ item.EntpCusName }}
                                                <span class="phone" v-if="item.Phone">
                                                    {{ ' ( 电话：' + item.Phone + ' )' }}
                                                </span>
                                            </div>
                                        </el-option>
                                    </el-select>
                                </el-form-item>
                            </div>
                        </el-col>
                        <el-col :span="4">
                            <div class="grid-content bg-purple">
                                <el-form-item label="物流单号" prop="LogisticsOrderNo">
                                    <el-input :disabled="dataReadonly" v-model.trim="submitData.LogisticsOrderNo"></el-input>
                                </el-form-item>
                            </div>
                        </el-col>
                    </el-row>
                    <el-row :gutter="20">
                        <el-col :span="12">
                            <div class="grid-content bg-purple">
                                <el-form-item label="收货地址" prop="FullAddress">
                                    <el-autocomplete v-model.trim="submitData.FullAddress" style="width: 100%" :fetch-suggestions="querySearch"></el-autocomplete>
                                </el-form-item>
                            </div>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="客人要求" class="grid-content bg-purple">
                                <el-tooltip :content="submitData.Remark" placement="top" effect="light" v-if="submitData.Remark && dataReadonly">
                                    <el-input :disabled="dataReadonly" v-model.trim="submitData.Remark"></el-input>
                                </el-tooltip>
                                <el-input v-else :disabled="dataReadonly" v-model.trim="submitData.Remark"></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>
                </el-form>
            </div>
            <!--    table    -->
            <div class="section-title" @click="hideMsg()">
                <div>商品明细</div>
                <div>
                    <el-button size="small" class="search-btn btn-primary" @click="showSearch()" v-if="!dataReadonly">搜索配件</el-button>
                </div>
            </div>
        </div>
        <!-- table body -->
        <div id="infinite-list" :class="infiniteListClass" :style="{ height: infiniteListHeight + 'px' }" @click="hideMsg()">
            <ux-grid
                ref="infiniteTable"
                :data="dataList"
                keep-source
                :height="infiniteTableHeight"
                :checkboxConfig="{ highlight: false }"
                :edit-config="{ trigger: 'click', mode: 'row' }"
                show-summary
                :summary-method="setSummaries"
                :row-style="setRowStyle"
                highlight-current-row
            >
                <ux-table-column class-name="table-sort" type="index" title="序号" width="65"></ux-table-column>

                <ux-table-column field="APCode" title="汽配编码" edit-render show-overflow-tooltip>
                    <template v-slot:header="{ column }">
                        <div class="head-view">
                            <span class="color-red">*</span> {{ column.title }}
                            <span class="sort-view">
                                <i :class="['el-icon-caret-top', { active: sortActive === 'top' }]" title="升序,从小到大排序" @click="changeTableSort('top', 'APCode')"></i>
                                <i
                                    :class="['el-icon-caret-bottom', { active: sortActive === 'bottom' }]"
                                    title="降序,从大到小排序"
                                    @click="changeTableSort('bottom', 'APCode')"
                                ></i>
                            </span>
                        </div>
                    </template>
                    <template v-slot="{ row, rowIndex }">
                        <div :class="['sales-apcode div-padding-12', { 'special-border': !row.APCode }]" @click="focusHandle(row.IsNew, rowIndex, 'code')">
                            <img class="info-icon" src="../../../assets/images/info.png" title="配件信息" @click.stop="showAPMsgDialog(row.EntpTempGoodsId)" />
                            <span>{{ row.APCode ? row.APCode : '请点击选中汽配编码' }}</span>
                            <el-tag v-if="row.State == 1" class="tag" type="warning">已删除</el-tag>
                        </div>
                    </template>
                    <template v-slot:edit="scope">
                        <el-select
                            style="width: 100%"
                            :ref="'code' + scope.rowIndex"
                            :disabled="dataReadonly || scope.row.hasLock"
                            allow-create
                            default-first-option
                            size="small"
                            v-model="scope.row.APCode"
                            value-key="APCode"
                            filterable
                            clearable
                            remote
                            reserve-keyword
                            placeholder="汽配编码"
                            @change="codeChange($event, scope.rowIndex)"
                            @visible-change="apCodeVisibleChange($event)"
                            @keyup.enter.native="addItem(true)"
                            :remote-method="searchCode"
                            v-select-scroll-more="searchCodeLoad"
                            popper-class="el-select-style-gray"
                        >
                            <el-option
                                v-for="optionItem in codeList"
                                :key="optionItem.EntpTempGoodsId"
                                :data-msg="optionItem"
                                :label="optionItem.APCode"
                                :value="optionItem.APCode"
                            >
                                <div class="option-content">
                                    <div class="project-Name">{{ optionItem.APCode }}</div>
                                    <div class="project-Name">{{ optionItem.GoodName }}</div>
                                    <div class="project-Name">
                                        {{ optionItem.AutoSerise }}
                                    </div>
                                    <div class="project-Name" v-if="changeCodeConfig">
                                        {{ optionItem.GoodCode }}
                                    </div>
                                </div>
                            </el-option>
                            <el-option v-if="loading" disabled value style="text-align: center"> 加载中 <i class="el-icon-loading"></i> </el-option>
                        </el-select>
                    </template>
                </ux-table-column>

                <ux-table-column field="GoodNameItem" title="配件名称" edit-render show-overflow-tooltip>
                    <template v-slot:header="{ column }"> <span class="color-red">*</span> {{ column.title }} </template>
                    <template v-slot="{ row, rowIndex }">
                        <div :class="['div-padding-12', { 'special-border': !row.GoodName }]" @click="focusHandle(row.IsNew, rowIndex, 'partsNameSelect')">
                            {{ row.GoodName }}
                        </div>
                    </template>
                    <template v-slot:edit="scope">
                        <el-input
                            size="small"
                            placeholder="配件名称"
                            v-model="scope.row.GoodName"
                            v-if="scope.row.IsNew"
                            :disabled="scope.row.hasLock && lastRowIndex !== scope.rowIndex"
                        ></el-input>
                        <el-select
                            v-else
                            ref="partsNameSelect"
                            style="width: 100%"
                            :disabled="dataReadonly || scope.row.hasLock"
                            allow-create
                            size="small"
                            v-model="scope.row.GoodNameItem"
                            :title="scope.row.GoodName"
                            value-key="EntpTempGoodsId"
                            filterable
                            clearable
                            remote
                            reserve-keyword
                            placeholder="配件名称"
                            @change="nameChange($event, scope.rowIndex)"
                            @visible-change="apNameVisibleChange($event)"
                            @keyup.enter.native="addItem(true)"
                            :remote-method="
                                query => {
                                    searchName(query, scope.row);
                                }
                            "
                            v-select-scroll-more="searchNameLoad"
                            popper-class="el-select-style-gray"
                        >
                            <el-option v-for="optionItem in nameList" :key="optionItem.EntpTempGoodsId" :data-msg="optionItem" :label="optionItem.GoodName" :value="optionItem">
                                <div class="option-content">
                                    <div class="project-Name">{{ optionItem.GoodName }}</div>
                                    <div class="project-Name">{{ optionItem.APCode }}</div>
                                    <div class="project-Name">
                                        {{ optionItem.AutoSerise }}
                                    </div>
                                    <div class="project-Name" v-if="changeCodeConfig">
                                        {{ optionItem.GoodCode }}
                                    </div>
                                </div>
                            </el-option>
                            <el-option v-if="loading" disabled value style="text-align: center"> 加载中 <i class="el-icon-loading"></i> </el-option>
                        </el-select>
                    </template>
                </ux-table-column>

                <ux-table-column field="AutoSeriseItem" title="车型" edit-render show-overflow-tooltip>
                    <template v-slot:header="{ column }"> <span class="color-red">*</span> {{ column.title }} </template>
                    <template v-slot="{ row, rowIndex }">
                        <el-tooltip effect="dark" :content="row.AutoSerise ? row.AutoSerise.toString() : ''" :disabled="!row.AutoSerise" placement="top">
                            <div :class="['div-padding-12', { 'special-border': !row.AutoSerise }]" @click="focusHandle(row.IsNew, rowIndex, 'autoSeriseSelect')">
                                {{ row.AutoSerise }}
                            </div>
                        </el-tooltip>
                    </template>
                    <template v-slot:edit="scope">
                        <el-input
                            size="small"
                            v-model="scope.row.AutoSerise"
                            placeholder="车系"
                            v-if="scope.row.IsNew"
                            :disabled="scope.row.hasLock && lastRowIndex !== scope.rowIndex"
                        ></el-input>
                        <el-select
                            v-else
                            ref="autoSeriseSelect"
                            style="width: 100%"
                            :disabled="dataReadonly || scope.row.hasLock"
                            allow-create
                            size="small"
                            v-model="scope.row.AutoSeriseItem"
                            :title="scope.row.AutoSerise"
                            value-key="EntpTempGoodsId"
                            filterable
                            clearable
                            remote
                            reserve-keyword
                            placeholder="车系"
                            @visible-change="autoSeriseVisibleChange($event, scope.row)"
                            @keyup.enter.native="addItem(true)"
                            :remote-method="
                                query => {
                                    searchAutoSerie(query, scope.row);
                                }
                            "
                            v-select-scroll-more="searchAutoSerieLoad"
                            @change="seriseChange($event, scope.rowIndex)"
                            popper-class="el-select-style-gray"
                        >
                            <el-option v-for="option in seriesList" :key="option.EntpTempGoodsId" :data-msg="option" :label="option.AutoSerise" :value="option">
                                <div class="option-content">
                                    <div class="project-Name" style="width: 300px">
                                        {{ option.AutoSerise }}
                                    </div>
                                    <div class="project-Name">{{ option.GoodName }}</div>
                                    <div class="project-Name">{{ option.APCode }}</div>
                                    <div class="project-Name" v-if="changeCodeConfig">
                                        {{ option.GoodCode }}
                                    </div>
                                </div>
                            </el-option>
                            <el-option v-if="loading" disabled value style="text-align: center"> 加载中 <i class="el-icon-loading"></i> </el-option>
                        </el-select>
                    </template>
                </ux-table-column>

                <ux-table-column field="Count" title="数量" width="100" edit-render>
                    <template v-slot="{ row }">
                        <div class="div-padding-12">{{ row.Count }}</div>
                    </template>
                    <template v-slot:edit="scope">
                        <div class="sales-input-cell">
                            <el-input-number
                                type="number"
                                :ref="'count' + scope.rowIndex"
                                :min="1"
                                :precision="0"
                                controls-position="right"
                                size="small"
                                v-model="scope.row.Count"
                                @change="priceChange"
                                @keyup.enter.native="addItem(true)"
                            ></el-input-number>
                        </div>
                    </template>
                </ux-table-column>

                <ux-table-column field="Unit" title="单位" width="100" edit-render>
                    <template v-slot:header="{ column }"> <span class="color-red">*</span> {{ column.title }} </template>
                    <template v-slot="{ row, rowIndex }">
                        <div :class="['div-padding-12', { 'special-border': !row.Unit }]" @click="focusHandle(row.IsNew, rowIndex, 'unitSelect')">
                            {{ row.Unit }}
                        </div>
                    </template>
                    <template v-slot:edit="scope">
                        <el-select
                            ref="unitSelect"
                            default-first-option
                            size="small"
                            v-model="scope.row.Unit"
                            filterable
                            clearable
                            remote
                            reserve-keyword
                            placeholder="单位"
                            @visible-change="unitVisibleChange($event)"
                            @keyup.enter.native="addItem(true)"
                            popper-class="el-select-style-gray"
                        >
                            <el-option v-for="optionItem in unitList" :key="optionItem.Value" :label="optionItem.Value" :value="optionItem.Value"></el-option>
                        </el-select>
                    </template>
                </ux-table-column>

                <ux-table-column field="ReferencePrice" title="参考售价" width="140">
                    <template v-slot:header="{ column }">
                        <el-tooltip effect="dark" placement="bottom">
                            <div slot="content">
                                当配件商品有过报价历史时，显示配件商品的最新报价价格；<br />
                                若配件商品从未报价给客户时，则显示配件商品的零售价格
                            </div>
                            <span>
                                <i class="el-icon-warning-outline" style="color: orange; margin-right: 5px"></i>
                            </span>
                        </el-tooltip>
                        {{ column.title }}
                    </template>
                    <template v-slot="{ row }">
                        <div class="div-padding-12 div-margin-op">
                            <img
                                src="@/assets/images/quote.png"
                                title="报价历史"
                                style="width: 25px; height: 25px"
                                v-if="row.EntpTempGoodsId"
                                @click.stop="showHistories(row.EntpTempGoodsId)"
                            />
                            <img
                                src="@/assets/images/cus.png"
                                style="width: 25px; height: 25px; margin-right: 4px"
                                title="销售历史"
                                v-if="row.EntpTempGoodsId"
                                @click.stop="showHistoryDialog(row.EntpTempGoodsId)"
                            />
                            {{ row.ReferencePrice }}
                        </div>
                    </template>
                </ux-table-column>

                <ux-table-column field="MarketPrice" title="销售价" width="120" edit-render>
                    <template v-slot:header="{ column }">
                        <el-tooltip effect="dark" placement="bottom">
                            <div slot="content">
                                当配件商品有过销售历史且该客户有购买历史时，显示该客户购买配件商品的最新销售价格；<br />
                                若配件商品从未销售过，则不显示数值
                            </div>
                            <span>
                                <i class="el-icon-warning-outline" style="color: orange; margin-right: 5px"></i>
                                <span class="color-red">*</span>
                            </span>
                        </el-tooltip>
                        {{ column.title }}
                    </template>
                    <template v-slot="{ row }">
                        <div
                            :class="[
                                'div-padding-12',
                                {
                                    'special-border': CheckLoseMoney(row.CostPrice, row.MarketPrice) || !row.MarketPrice
                                }
                            ]"
                        >
                            <span
                                :class="{
                                    'color-red': row.MarketPrice === 0 || row.MarketPrice < row.CostPrice
                                }"
                                >{{ row.MarketPrice }}</span
                            >
                        </div>
                    </template>
                    <template v-slot:edit="scope">
                        <div
                            class="sales-input-cell"
                            v-if="(LoseMoneyValue && !dataReadonly && !scope.row.WarehousedCount > 0) || priceCanBeEdit"
                            :class="{
                                loseMoneyWarning: CheckLoseMoney(scope.row.CostPrice, scope.row.MarketPrice)
                            }"
                        >
                            <el-tooltip :disabled="!CheckLoseMoney(scope.row.CostPrice, scope.row.MarketPrice)" effect="light" placement="right">
                                <div slot="content">销售价低于成本价{{ LoseMoneyValue }}%</div>
                                <el-input-number
                                    size="small"
                                    :min="0"
                                    :precision="2"
                                    :step="0.01"
                                    controls-position="right"
                                    v-model="scope.row.MarketPrice"
                                    placeholder="销售价"
                                    @input="priceChange"
                                    @keyup.enter.native="addItem(true)"
                                ></el-input-number>
                            </el-tooltip>
                        </div>
                        <div class="sales-input-cell" v-else>
                            <el-input-number
                                size="small"
                                :min="0"
                                :precision="2"
                                :step="0.01"
                                controls-position="right"
                                v-model="scope.row.MarketPrice"
                                placeholder="销售价"
                                @input="priceChange"
                                @keyup.enter.native="addItem(true)"
                            ></el-input-number>
                        </div>
                    </template>
                </ux-table-column>

                <ux-table-column field="xszj" title="销售总价" width="80">
                    <template v-slot="{ row }">
                        <div class="div-padding-12">
                            {{ (row.MarketPrice * row.Count).toFixed(2) }}
                        </div>
                    </template>
                </ux-table-column>

                <ux-table-column field="ly" title="留余" width="80">
                    <template v-slot:header="{ column }">
                        <el-tooltip effect="dark" placement="bottom">
                            <div slot="content">
                                若未选定出仓仓库，显示的留余数为总库存的商品留余数；<br />
                                若已选中出仓仓库，显示的留余数为该仓库下的商品留余数；<br />
                                注意：这里不统计退货的商品数量
                            </div>
                            <span>
                                <i class="el-icon-warning-outline" style="color: orange; margin-right: 5px"></i>
                            </span>
                        </el-tooltip>
                        {{ column.title }}
                    </template>
                    <template v-slot="{ row }">
                        <div class="div-padding-12">
                            <el-tooltip
                                effect="dark"
                                :content="
                                    '待入仓(' +
                                        row.POrderWaitInQuantity +
                                        '）  待出仓(' +
                                        row.OrderWaitOutQuantity +
                                        '）  库存(' +
                                        (submitData.WarehouseId ? row.StorageInventory : row.Inventory) +
                                        '）'
                                "
                                placement="top"
                            >
                                <span
                                    :class="{
                                        'color-red':
                                            (submitData.WarehouseId ? row.StorageInventory : row.Inventory) +
                                                (isAddWaitIn ? row.POrderWaitInQuantity : 0) -
                                                row.OrderWaitOutQuantity <=
                                            0
                                    }"
                                    >{{
                                        (submitData.WarehouseId ? row.StorageInventory : row.Inventory) + (isAddWaitIn ? row.POrderWaitInQuantity : 0) - row.OrderWaitOutQuantity
                                    }}</span
                                >
                            </el-tooltip>
                        </div>
                    </template>
                </ux-table-column>

                <ux-table-column title="操作" width="120">
                    <template v-slot="{ row, rowIndex }">
                        <div class="operate">
                            <el-button size="small" @click="delItem(rowIndex)" icon="el-icon-delete" v-if="dataList.length !== 1"></el-button>
                            <el-button size="small" type="primary" @click="addItem(true)" icon="el-icon-plus" v-if="rowIndex + 1 === dataList.length && !dataReadonly"></el-button>
                            <el-button
                                size="small"
                                @click="upLock(rowIndex)"
                                :icon="row.hasLock ? 'el-icon-lock' : 'el-icon-unlock'"
                                v-if="isLock && lastRowIndex !== rowIndex"
                            ></el-button>
                        </div>
                    </template>
                </ux-table-column>
            </ux-grid>

            <div class="bottom-div" @click="hideMsg">
                <div class="ship-amount" v-if="noFee">
                    运费：<span class="discount-count">￥ {{ submitData.ShipAmount * 1 }}</span>
                </div>
                <div :class="['subzone', { 'no-fee': !noFee }]">
                    <div class="part">
                        <div class="dismoney">
                            <div class="distitle">
                                <el-select v-model="discountId" :disabled="dataReadonly || (type == 8 && hasPaid)" placeholder="请选择">
                                    <el-option v-for="item in discountOptions" :key="item.id" :label="item.value" :value="item.id"> </el-option>
                                </el-select>
                            </div>
                            <el-input-number
                                v-if="discountId === 0"
                                size="small"
                                :disabled="dataReadonly || (type == 8 && hasPaid)"
                                v-model="submitData.DiscountAmount"
                                :min="0"
                                :step="0.01"
                                :precision="2"
                                controls-position="right"
                                :max="Number(allMoney.toFixed(2))"
                                style="width: 134px"
                            ></el-input-number>
                            <div class="percent-view" v-else>
                                <el-input-number
                                    placeholder="请输入"
                                    :controls="false"
                                    :min="0"
                                    :max="100"
                                    :precision="2"
                                    :disabled="dataReadonly || (type == 8 && hasPaid)"
                                    v-model="discountPercent"
                                >
                                </el-input-number>
                                <span>%</span>
                            </div>
                        </div>
                    </div>
                    <div class="part">
                        <div>
                            <span style="margin: 0 12px" v-if="!noFee">=</span>
                            实收金额：<span class="discount-count">￥ {{ discountCount }}</span>
                        </div>
                        <div v-if="!dataReadonly">
                            <el-button size="small" class="search-btn btn-primary" @click.stop="submitForm(type, 0)" v-if="permission.save && type != 8" :disabled="saving">{{
                                permission.save
                            }}</el-button>
                            <el-button size="small" class="search-btn btn-primary" @click.stop="submitForm(type, 1)" v-if="permission.submit" :disabled="saving">{{
                                permission.submit
                            }}</el-button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!--   搜索配件    -->
        <el-dialog :close-on-click-modal="false" title="搜索配件" :visible.sync="searchVisible" width="1248px">
            <div v-if="searchVisible">
                <searchAP
                    :EntpCusId="submitData.EntpCusId"
                    :EntpCusName="submitData.EntpCusName"
                    :StorageId="submitData.WarehouseId"
                    :Source="0"
                    :SelectedData="selectedData"
                    @chooseAllAPsHandle="chooseAllAPsHandle"
                    @closeDialog="closeSearchDialog"
                ></searchAP>
            </div>
        </el-dialog>
        <!--    销售历史    -->
        <el-dialog :close-on-click-modal="false" title="销售历史" :visible.sync="historyVisible" width="1200px">
            <div v-if="historyVisible">
                <APHistory
                    :EntpCusId="submitData.EntpCusId"
                    :EntpTempGoodsId="EntpTempGoodsIdEdit"
                    :EntpCusName="submitData.EntpCusName"
                    @closeDialog="closeHistoryDialog"
                ></APHistory>
            </div>
        </el-dialog>
        <!--    报价历史    -->
        <el-dialog :close-on-click-modal="false" title="报价历史" :visible.sync="historyQuoteVisible" width="1200px">
            <div v-if="historyQuoteVisible">
                <APQuoteHistory
                    :EntpCusId="submitData.EntpCusId"
                    :EntpTempGoodsId="EntpTempGoodsIdEdit"
                    :EntpCusName="submitData.EntpCusName"
                    @closeDialog="closeHistoryDialog"
                ></APQuoteHistory>
            </div>
        </el-dialog>
        <!--   配件信息     -->
        <el-dialog :close-on-click-modal="false" title="配件信息" :visible.sync="APMsgVisible" width="1000px">
            <div v-if="APMsgVisible">
                <APMsg :dialogFormVisible="APMsgVisible" :EntpTempGoodsId="EntpTempGoodsIdEdit" @closeDialog="closeAPMsgDialog"></APMsg>
            </div>
        </el-dialog>
        <!--  打印  -->
        <el-dialog :show-close="false" :close-on-click-modal="false" title="打印" :visible.sync="dialogPrintCHVisible" width="870px">
            <div class="dialog-content" v-if="dialogPrintCHVisible">
                <printContent @closePrintDialog="closePrintDialog" :printIds="idList" :printType="1"></printContent>
            </div>
        </el-dialog>
        <!--  打印英文版  -->
        <el-dialog :show-close="false" :close-on-click-modal="false" title="打印英文销售单" :visible.sync="dialogPrintEngVisible" width="870px">
            <div class="dialog-content" v-if="dialogPrintEngVisible">
                <printEngContent @closePrintDialog="closePrintDialog" :printIds="idList" :printType="1"></printEngContent>
            </div>
        </el-dialog>
        <el-dialog title="提示" :visible.sync="dialogPrint" :close-on-click-modal="false" width="500px">
            <div
                style="
          width: 100%;
          height: 100%;
          text-align: center;
          margin: 25px 0px 25px 0px;
        "
            >
                <span style="font-size: 16px" v-if="warehouseType == 0"> <i class="el-icon-info" style="color: #67c23a"></i>是否需要提交并打印？ </span>
                <span style="font-size: 16px" v-else> <i class="el-icon-info" style="color: #67c23a"></i>是否需要提交？ </span>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button size="mini" type="primary" @click="submit(0)" :disabled="saving">提交</el-button>
                <el-button size="mini" type="primary" @click="submit(1)" v-if="warehouseType == 0 && permission.print" :disabled="saving">提交，打印中文版</el-button>
                <el-button size="mini" type="primary" @click="submit(2)" :disabled="saving" v-if="warehouseType == 0 && permission.printEng">提交，打印英文版</el-button>
                <el-button size="mini" @click="canclePrint" :disabled="saving">取消</el-button>
            </span>
        </el-dialog>
        <el-progress v-if="searchApParams._visible" class="saveProgress" type="circle" :percentage="searchApParams._percentage" />
    </div>
</template>
<script>
import Vue from 'vue';
import printEngContent from '@/components/business/salesManage/printSalesEng';
import breadcrumb from '@/components/common/breadcrumb';
import searchAP from '@/components/common/searchAP';
import APMsg from '@/components/common/APMsg';
import APHistory from '@/components/common/APHistory';
import APQuoteHistory from '@/components/common/APQuoteHistory';
import mixin from '@/mixins/mixin';
export default {
    mixins: [mixin],
    name: '',
    components: {
        searchAP,
        APMsg,
        APHistory,
        APQuoteHistory,
        breadcrumb,
        printEngContent
    },
    watch: {
        $route(to, from) {
            if (to === this.$route) {
                this.init();
                this.submitData = {};
                this.allMoney = 0;
                this.allNum = 0;
                this.dataList = [];
            }
        }
    },
    data() {
        let checkPositive = this.$util.checkPositive;
        let userMsg = this.$util.getLocalStorage('userMsg');
        return {
            userMsg: userMsg,
            idList: [],
            addressList: [],
            postType: 0,
            dialogPrintCHVisible: false,
            dialogPrintEngVisible: false,
            dialogPrint: false,
            needConfirm: true,
            SIdList: [
                {
                    EmployeeId: userMsg.EmployeeId,
                    EmployeeName: userMsg.EmployeeName
                }
            ],
            FollowerList: [],
            EntpTempGoodsIdEdit: '',
            loading: false,
            saving: false,
            warehouseType: 0,
            dataReadonly: false,
            showOrderMsg: true,
            APMsgVisible: false,
            historyVisible: false,
            searchVisible: false,
            ReceiptVisible: false,
            dialogVisible: false,
            outVisible: false,
            historyQuoteVisible: false,
            allNum: 1,
            allMoney: 0,
            customerEditType: 1,
            submitData: {
                SId: userMsg.EmployeeId,
                ReleOrderId: '',
                WarehouseId: '',
                WarehouseName: '',
                FollowerId: '',
                SubmissionState: false,
                ShipAmount: '',
                DiscountAmount: '',
                EntpCusId: '',
                PayType: '',
                ShipType: '',
                FullAddress: '',
                PhoneNum: '',
                Remark: '',
                DetailList: [],
                LogisticId: '',
                LogisticName: '',
                LogisticItem: '',
                LogisticsOrderNo: '',
                ReleType: ''
            },
            Limit: 10,
            customerList: [],
            DeliveryMethodList: [], // 发货方式列表
            payWayList: [],
            codeList: [],
            nameList: [],
            seriesList: [],
            dataList: [],
            unitList: [],
            warehouseList: [], //仓库列表
            warehouseGoodsList: [], //入库商品列表
            type: 1, //  1 查看 2 编辑 3 新增 4 从库存配件管理过来的
            id: '',
            pageTitle: '',
            rules: {
                ShipType: [
                    {
                        required: true,
                        message: '请选择发货方式',
                        trigger: 'blur'
                    }
                ],
                EntpCusId: [
                    {
                        required: true,
                        message: '请选择客户',
                        trigger: 'blur'
                    }
                ],
                SId: [
                    {
                        required: true,
                        message: '请选择业务员',
                        trigger: 'blur'
                    }
                ],
                PhoneNum: [
                    {
                        required: true,
                        message: '填写电话号码',
                        trigger: 'blur'
                    }
                ],
                FullAddress: [
                    {
                        required: true,
                        message: '填写收货地址',
                        trigger: 'change'
                    }
                ],
                PayType: [
                    {
                        required: true,
                        message: '填写结算方式',
                        trigger: 'blur'
                    }
                ],
                ShipAmount: [
                    {
                        validator: checkPositive,
                        trigger: 'blur'
                    }
                ],
                WarehouseId: [{ required: true, message: '请选择仓库', trigger: 'blur' }]
            },
            permission: {},
            funcConfig: false,
            discountId: 0,
            discountOptions: [
                { id: 0, value: '优惠金额' },
                { id: 1, value: '整单优惠' }
            ],
            discountPercent: 0,
            LoseMoneyValue: 0, //亏本指标
            priceCanBeZero: false,
            priceCanBeEdit: false,
            changeCodeConfig: false,
            // 是否预先加载汽配编码列表数据
            isPreloadApCodeList: false,

            infiniteListHeight: 0, // 列表高度，在收起信息栏时进行实时计算
            selectedData: [],
            logisticsList: [],
            apcodeSource: null, // 用于处理取消编码请求操作
            // 用于客户名称列表，分页搜索
            cusForm: {
                Page: 1,
                Limit: 10,
                stopLoad: false,
                key: ''
            },
            // 用于汽配编码列表，分页搜索功能
            codeForm: {
                Page: 1,
                Limit: 10,
                stopLoad: false,
                key: ''
            },
            // 用于配件名称列表，分页搜索功能
            nameForm: {
                Page: 1,
                Limit: 10,
                stopLoad: false,
                key: ''
            },
            // 用于车型列表，分页搜索功能
            autoSerieForm: {
                Page: 1,
                Limit: 10,
                stopLoad: false,
                key: ''
            },
            // 加锁：选择商品完成回车或点加号后触发锁定不可修改
            hasLock: true,
            // 汽配编码排序标识
            sortActive: '',
            // 进度条
            // 搜索配件弹框返回参数
            searchApParams: {
                _visible: false,
                _percentage: 0,
                _limit: 500,
                // 总数量
                _totalCount: 0
            },
            isAddWaitIn: true
        };
    },
    beforeRouteLeave(to, from, next) {
        this.$util.confirmBeforeLeave(to, from, next, this);
    },
    created() {
        this.getSendWay();
        this.getPay();
        this.getConfigByCodes();
    },
    mounted() {
        let that = this;
        that.init();
        // 监听滚动事件
        window.onresize = () => {
            that.resetHeight();
        };
        Vue.component('printContent', function(resolve) {
            that.$util.getPrintComponents().then(data => {
                if (data) {
                    require(['@/components/printModels/' + data], resolve);
                } else {
                    require(['@/components/printModels/printSales'], resolve);
                }
            });
        });
    },
    computed: {
        noFee() {
            return this.submitData.ShipAmount && this.submitData.ShipAmount * 1 !== 0;
        },
        // 优惠后的金额
        discountCount() {
            let discountCount = this.submitData.DiscountAmount;
            let shipAmount = this.submitData.ShipAmount ? this.submitData.ShipAmount * 1 : 0;
            if (!discountCount) {
                return (this.allMoney * 1 + shipAmount).toFixed(2);
            }
            if (this.discountId === 1) {
                // 处理整单优惠
                discountCount = (this.discountPercent / 100) * this.allMoney;
            }
            return (this.allMoney * 1 - discountCount + shipAmount).toFixed(2);
        },
        // 当type为6时定义新样式
        infiniteListClass() {
            return '';
        },
        // 列表高度，当type为6时高度自适应
        infiniteTableHeight() {
            let bottomHeight = this.noFee ? 158 : 78;
            let resultHeight = this.infiniteListHeight - bottomHeight;
            return resultHeight;
        },
        // 是否加锁
        isLock() {
            return this.hasLock;
        },
        // 列表数据最后一行下标
        lastRowIndex() {
            return Array.isArray(this.dataList) ? this.dataList.length - 1 : 0;
        },
        // 收款金额是否大于零，当为true时，不能修改优惠金额
        hasPaid() {
            return this.submitData.Paid && this.submitData.Paid * 1 > 0;
        }
    },
    methods: {
        getConfigByCodes() {
            let codes = ['kdyjz', 'xsgdy', 'xskbzb', 'xsspjgwl', 'xgxsjg', 'lybsdr', 'kdbjsd', 'ddhhm'];
            this.$util.getSysConfigs(codes).then(data => {
                if (data) {
                    for (let i = 0; i < data.length; i++) {
                        let code = data[i].Code;
                        let result = data[i].Result;
                        let rValue = data[i].RValue;
                        switch (code) {
                            case 'kdyjz': // 获取预加载商品数据的功能设置结果
                                this.isPreloadApCodeList = result;
                                break;
                            case 'xsgdy': //获取企业的功能设置结果
                                this.funcConfig = result;
                                break;
                            case 'xskbzb': //获取销售商品亏本指标
                                this.LoseMoneyValue = result ? Number(rValue) : 0;
                                break;
                            case 'xsspjgwl': //获取销售价可为零配置
                                this.priceCanBeZero = result;
                                break;
                            case 'xgxsjg':
                                this.priceCanBeEdit = result;
                                break;
                            case 'lybsdr': //获取留余的计算方式
                                this.isAddWaitIn = !result;
                                break;
                            case 'kdbjsd': //获取权限：选择商品完成回车或点加号后触发锁定不可修改
                                this.hasLock = result;
                                break;
                            case 'ddhhm':
                                this.changeCodeConfig = result;
                                break;
                        }
                    }
                }
            });
        },
        // 编码排序
        changeTableSort(type, prop) {
            let sortArr = [];
            let listArr = this.dataList.filter(f => f[prop]);
            let otherArr = this.dataList.filter(f => !f[prop]);
            if (type === 'top') {
                this.sortActive = 'top';
                sortArr = listArr.sort((a, b) => a[prop].localeCompare(b[prop]));
            } else {
                this.sortActive = 'bottom';
                sortArr = listArr.sort((a, b) => b[prop].localeCompare(a[prop]));
            }
            this.dataList = [...sortArr, ...otherArr];
        },
        // 计算infinite-list高度
        resetHeight() {
            let listObj = document.getElementById('infinite-list');
            if (!listObj) return;
            let clientObj = listObj.getBoundingClientRect();
            this.infiniteListHeight = window.innerHeight - clientObj.top;
        },
        init() {
            this.permission = this.$util.getPermission('salesOrder');

            this.id = this.$route.query.orderId;
            this.submitData.EntpCusId = this.$route.query.entpCusId;
            this.submitData.EntpCusName = this.$route.query.entpCusName;
            this.submitData.ReleOrderId = this.$route.query.orderId;
            this.submitData.ReleType = this.$route.query.releType;
            this.type = Number(this.$route.query.type);
            this.getdefaultWarehouses();
            let _dataList = this.$util.getLocalStorage('UnionTansOrder');
            for (let i = 0; i < _dataList.length; i++) {
                this.dataList.push({
                    EntpTempGoodsId: _dataList[i].MyGoodsId,
                    APCode: _dataList[i].MyAPCode,
                    GoodName: _dataList[i].GoodName,
                    GoodNameItem: _dataList[i].GoodName,
                    AutoSerise: _dataList[i].AutoSerise,
                    AutoSeriseItem: _dataList[i].AutoSerise,
                    Count: _dataList[i].Count,
                    MarketPrice: _dataList[i].Price,
                    Unit: _dataList[i].Unit,
                    Remark: '',
                    CostPrice: '',
                    State: 0,
                    WaitingOutQuantity: 0,
                    Inventory: 0, //商品总数量
                    StorageInventory: 0, //仓库库存数量
                    POrderWaitInQuantity: 0,
                    OrderWaitOutQuantity: 0,
                    hasLock: this.hasLock
                });
            }
            // 上锁
            if (this.isLock && this.dataList.length > 1) {
                this.dataList.forEach(ele => {
                    ele.hasLock = true;
                });
            }
            this.priceChange();
            this.getDefaultData();
            setTimeout(() => {
                this.resetHeight();
            }, 0);

            this.getTranOrderDefaultData();
        },
        getTranOrderDefaultData() {
            let that = this;

            if (that.dataList) {
                let ids = [];
                that.dataList.forEach((e, i) => {
                    if (e.EntpTempGoodsId) ids.push(e.EntpTempGoodsId);
                });
                if (ids.length > 0) {
                    that.$util
                        .axiosPost({
                            url: '/api/EntpUnions/GetTranOrderDefaultData',
                            data: {
                                EntpCusId: that.submitData.EntpCusId,
                                GoodsIds: ids,
                                WarehouseId: that.submitData.submitData
                            }
                        })
                        .then(res => {
                            if (res.data) {
                                let data = res.data.DetailList;
                                that.submitData.PhoneNum = res.data.PhoneNum;
                                that.submitData.FullAddress = res.data.Address;
                                that.dataList.forEach((e, i) => {
                                    let goodsData = data.find(d => d.GoodsId == e.EntpTempGoodsId);
                                    if (goodsData) {
                                        e.StorageInventory = goodsData.StorageInventory;
                                        e.OrderWaitOutQuantity = goodsData.OrderWaitOutQuantity;
                                        e.POrderWaitInQuantity = goodsData.POrderWaitInQuantity;
                                        e.Inventory = goodsData.Inventory;
                                        e.ReferencePrice = goodsData.ReferencePrice;
                                        e.CostPrice = goodsData.CostPrice;
                                        e.State = goodsData.State;
                                    } else {
                                        e.StorageInventory = 0;
                                        e.OrderWaitOutQuantity = 0;
                                        e.POrderWaitInQuantity = 0;
                                        e.Inventory = 0;
                                    }
                                });
                            }
                        })
                        .catch(() => {});
                }
            }
        },
        closePrintDialog() {
            this.dialogPrint = false;
            this.dialogPrintCHVisible = false;
            this.dialogPrintEngVisible = false;
        },
        canclePrint() {
            this.dialogPrint = false;
        },
        getSIdList() {
            this.$util.getSysConfig('sjqx').then(res => {
                if (res.Result) {
                    this.$util.getAuthSIdList().then(data => {
                        this.SIdList = data;
                    });
                    this.$util.getSIdList().then(data => {
                        this.FollowerList = data;
                    });
                } else {
                    this.$util.getSIdList().then(data => {
                        this.SIdList = data;
                        this.FollowerList = data;
                    });
                }
            });
        },
        getConfigData() {
            this.$util.searchGoodsUnit().then(res => {
                this.unitList = res;
            });
        },
        // 搜索
        showSearch() {
            if (this.dataList.length > 0) {
                this.selectedData = [];
                this.dataList.forEach(item => {
                    if (item.EntpTempGoodsId) this.selectedData.push(item.EntpTempGoodsId);
                });
            }
            this.searchVisible = true;
        },
        // 搜索配件弹框 - 确认筛选结果按钮操作
        chooseAllAPsHandle(data) {
            this.searchVisible = false;
            this.searchApParams = {
                ...data.searchData,
                limit: this.searchApParams._limit,
                _visible: true,
                _percentage: 0,
                _limit: this.searchApParams._limit,
                _totalCount: data.searchData.limit
            };
            this.loopSearch();
        },
        // 开始循环
        async loopSearch() {
            const { data } = await this.$util.axiosPost({
                url: '/api/EntpGoods/GetFullDataGoodsListForOrder',
                data: this.searchApParams,
                hideLoading: true
            });
            this.searchApParams._percentage = parseInt(((this.searchApParams.page * this.searchApParams.limit) / this.searchApParams._totalCount) * 100);
            this.searchApParams.page += 1;
            let _stop = !data || data.length < this.searchApParams._limit;
            this.closeSearchDialog(data);
            if (_stop) {
                this.searchApParams._percentage = 100;
                this.searchApParams._visible = false;
            } else {
                this.loopSearch();
            }
        },
        // 搜索配件弹框 - 关闭弹框并更新页面数据
        closeSearchDialog(items) {
            let that = this;
            let itemList = [...items];
            if (itemList.length == 0) {
                that.searchVisible = false;
                return;
            }
            let newGoodsList = [];
            for (let i = 0; i < itemList.length; i++) {
                let item = itemList[i];
                let isExist = false;
                that.dataList.forEach((e, index) => {
                    if (item.APCode == e.APCode) {
                        isExist = true;
                        e.StorageInventory = item.StorageInventory;
                        e.MarketPrice = item.LatestPrice > 0 ? item.LatestPrice : '';
                    }
                });
                if (!isExist) {
                    let newGoods = {
                        ReferencePrice: item.ReferencePrice,
                        EntpTempGoodsId: item.EntpTempGoodsId,
                        APCode: item.APCode,
                        GoodName: item.GoodName,
                        GoodNameItem: item.GoodName,
                        AutoSerise: item.AutoSerise,
                        AutoSeriseItem: item.AutoSerise,
                        Count: 1,
                        MarketPrice: item.LatestPrice > 0 ? item.LatestPrice : '',
                        Unit: item.Unit,
                        Remark: '',
                        CodeRepeat: false,
                        Inventory: item.Inventory,
                        StorageInventory: item.StorageInventory,
                        WarehousedCount: 0,
                        OrderWaitOutQuantity: item.OrderWaitOutQuantity,
                        POrderWaitInQuantity: item.POrderWaitInQuantity,
                        State: 0,
                        // 是否可编辑，用于报价转销售情况时新增数据情况
                        canEdit: false
                    };
                    newGoodsList.push(newGoods);
                }
            }
            //判断最后一条数据是否空值，是的话移到最后
            if (that.dataList.length == 0) {
                that.dataList = that.dataList.concat(newGoodsList);
            } else {
                let lastItem = that.dataList[that.dataList.length - 1];
                if (!lastItem.APCode && !lastItem.GoodName) {
                    that.dataList.splice(that.dataList.length - 1, 1);
                    that.dataList = that.dataList.concat(newGoodsList);
                    that.dataList.push(lastItem);
                } else {
                    that.dataList = that.dataList.concat(newGoodsList);
                }
            }

            that.priceChange();
            that.searchVisible = false;
        },
        // 配件信息
        showAPMsgDialog(id) {
            if (id) {
                this.EntpTempGoodsIdEdit = id;
                this.APMsgVisible = true;
            }
        },
        closeAPMsgDialog(edit) {
            this.APMsgVisible = false;
        },
        // 历史销售
        showHistoryDialog(id) {
            if (id) {
                this.EntpTempGoodsIdEdit = id;
                this.historyVisible = true;
            }
        },
        closeHistoryDialog(edit) {
            this.historyVisible = false;
            this.historyQuoteVisible = false;
        },
        showHistories(id) {
            if (id) {
                this.EntpTempGoodsIdEdit = id;
                this.historyQuoteVisible = true;
            }
        },
        // 配件信息
        hideMsg() {
            this.showOrderMsg = false;
            setTimeout(() => {
                this.resetHeight();
            }, 100);
        },
        showMsg() {
            this.showOrderMsg = true;
            setTimeout(() => {
                this.resetHeight();
            }, 100);
        },
        // 数量或者价格变动
        priceChange() {
            let DetailList = this.dataList;
            let _allNum = 0;
            let _allMoney = 0;
            for (let i = 0; i < DetailList.length; i++) {
                _allNum += Number(DetailList[i].Count);
                _allMoney += Number(DetailList[i].Count * DetailList[i].MarketPrice ? (DetailList[i].Count * DetailList[i].MarketPrice).toFixed(3) : 0);
            }
            this.allMoney = _allMoney;
            this.allNum = _allNum;
            // this.dataList = DetailList;
        },
        // 提交销售单
        submitForm(type, SubmissionState) {
            this.$refs['formMsg'].validate(valid => {
                if (valid) {
                    let _dataList = this.dataList;
                    if (!this.submitData.EntpCusId && this.type != 4) {
                        this.$util.warningMsg('请选择客户');
                        this.showMsg();
                        return;
                    }
                    if (this.discountId === 1) {
                        // 处理整单优惠
                        this.submitData.DiscountAmount = (this.discountPercent / 100) * this.allMoney;
                    }
                    if (this.submitData.DiscountAmount > this.allMoney) {
                        this.$util.warningMsg('优惠金额不能大于订单总额');
                        return;
                    }
                    for (let i = 0; i < _dataList.length; i++) {
                        if (!_dataList[i].APCode) {
                            this.$util.warningMsg('请填写配件编码');
                            return;
                        }
                        if (!_dataList[i].GoodName) {
                            this.$util.warningMsg('请填写配件名称');
                            return;
                        }
                        if (_dataList[i].State != 0) {
                            this.$util.warningMsg('商品【' + _dataList[i].GoodName + '（' + _dataList[i].APCode + '）' + '】已删除');
                            return;
                        }
                        if (!_dataList[i].AutoSerise) {
                            this.$util.warningMsg('请填写车型');
                            return;
                        }
                        if (!_dataList[i].Count || _dataList[i].Count < 0) {
                            this.$util.warningMsg('请填写正确的数量');
                            return;
                        } else {
                            if (!_dataList[i].IsDelivery && _dataList[i].WarehousedCount > 0 && _dataList[i].Count < _dataList[i].WarehousedCount) {
                                this.$util.warningMsg('商品数量不能少于已出仓数，已出仓' + _dataList[i].WarehousedCount + '个商品');
                                return;
                            }
                        }
                        if (!_dataList[i].Unit) {
                            this.$util.warningMsg('请填写单位');
                            return;
                        }
                        if (!this.priceCanBeZero && !_dataList[i].MarketPrice) {
                            this.$util.warningMsg('销售价不能小于0');
                            return;
                        }
                        if (!this.priceCanBeZero) {
                            if (!_dataList[i].MarketPrice && !_dataList[i].Price) {
                                this.$util.warningMsg('请填写销售价');
                                return;
                            }
                            if (_dataList[i].MarketPrice == 0) {
                                this.$util.warningMsg('销售价不能为0');
                                return;
                            }
                        }
                        if (_dataList[i].MarketPrice >= 0) {
                            _dataList[i].Price = _dataList[i].MarketPrice;
                        }
                    }

                    this.postType = type;
                    this.submitData.DetailList = _dataList;
                    this.submitData.SubmissionState = SubmissionState;

                    let checkRepeat = this.checkRepeatAndReturnData();
                    if (checkRepeat.hasRepeat) {
                        this.$confirm('订单含有重复商品项，是否需要累加', '', {
                            type: 'error',
                            distinguishCancelAndClose: true
                        })
                            .then(() => {
                                // 覆盖数据
                                this.dataList = checkRepeat.row;
                                this.submitData.DetailList = checkRepeat.row;
                                this.submitBefore(SubmissionState);
                            })
                            .catch(() => {});
                    } else {
                        this.submitBefore(SubmissionState);
                    }
                } else {
                    this.$util.warningMsg('有必填项未填写');
                    this.showMsg();
                }
            });
        },
        // 提交前确认
        submitBefore(SubmissionState) {
            switch (SubmissionState) {
                case 0: //保存
                    this.submit(0); //不打印
                    break;
                case 1: //提交
                    this.dialogPrint = true;
                    break;
            }
        },
        submit(printType) {
            let that = this;
            if (that.saving) return;
            that.saving = true; //防止多次点击
            that.dialogPrint = false;

            let url = '/api/EntpUnions/TranEnterpriseCustomerSaleOrder';
            that.$util
                .axiosPost({
                    url: url,
                    data: that.submitData
                })
                .then(res => {
                    if (res.errcode == 0) {
                        that.needConfirm = false;

                        that.idList = [];
                        if (res.data) {
                            //新增
                            that.idList.push(res.data);
                        }

                        //清除销售订单缓存
                        that.removePageChace();

                        let CacheList=[];
                        //添加默认出仓仓库
                        if (that.submitData.WarehouseId) {
                            var wd= {
                                    WarehouseId: that.submitData.WarehouseId,
                                    WarehouseName: that.submitData.WarehouseName,
                                    WarehouseType: that.warehouseType
                                    };
                            CacheList.push({CacheKey:'defaultOutWarehouses',CacheValue:JSON.stringify(wd),CacheType:'1'});
                            that.$util.SetEntpCache(CacheList);
                        }

                        if (this.submitData.SubmissionState == 0) this.$util.successMsg('保存销售订单成功');
                        else this.$util.successMsg('提交销售订单成功');

                        switch (printType) {
                            case 1:
                                that.dialogPrintCHVisible = true;
                                break;
                            case 2:
                                that.dialogPrintEngVisible = true;
                                break;
                            case 0:
                                that.$store.commit('updateNeedRefresh', true);
                                setTimeout(() => {
                                    that.$router.push('/salesManage/salesOrder');
                                }, 2000);
                                break;
                        }
                    }
                })
                .catch(() => {
                    that.saving = false;
                });
        },
        // 检查是否有重复项及返回已合并数量的数据
        checkRepeatAndReturnData() {
            let [list, row, hasRepeat] = [this.submitData.DetailList, [], false];
            list.forEach(item => {
                let index = row.findIndex(f => f.APCode === item.APCode);
                if (index > -1) {
                    hasRepeat = true;
                    row[index].Count += item.Count;
                } else {
                    row.push(Object.assign({}, item));
                }
            });
            return {
                hasRepeat,
                row
            };
        },
        // 删除某行
        delItem(index) {
            if (this.dataList.length != 1) {
                this.dataList.splice(index, 1);
            }
            this.priceChange();
            this.addPageChace(); //添加销售订单缓存
        },
        // 添加一行
        addItem(addPageChace) {
            if (this.dataReadonly) return;
            let _dataList = this.dataList;
            for (let i = 0; i < _dataList.length; i++) {
                if (!_dataList[i].APCode) {
                    this.$util.warningMsg('请填写配件编码');
                    return;
                }
                if (!_dataList[i].GoodName) {
                    this.$util.warningMsg('请填写配件名称');
                    return;
                }
                if (!_dataList[i].AutoSerise) {
                    this.$util.warningMsg('请填写车型');
                    return;
                }
                if (!_dataList[i].Unit) {
                    this.$util.warningMsg('请填写单位');
                    return;
                }
                if (!this.priceCanBeZero) {
                    if (!_dataList[i].MarketPrice) {
                        this.$util.warningMsg('请填写销售价');
                        return;
                    }
                }
            }
            if (addPageChace) {
                this.addPageChace(); //添加销售订单缓存
            }

            // 上锁
            if (this.isLock) {
                this.dataList.forEach(ele => {
                    ele.hasLock = true;
                });
            }

            this.dataList.push({
                WaitingOutQuantity: 0,
                Inventory: 0, //商品总数量
                StorageInventory: 0, //仓库库存数量
                ReferencePrice: 0,
                EntpTempGoodsId: '',
                APCode: '',
                GoodName: '',
                GoodNameItem: '',
                AutoSerise: '',
                AutoSeriseItem: '',
                Count: '1',
                MarketPrice: '',
                CostPrice: 0,
                Unit: '',
                Remark: '',
                CodeRepeat: false,
                IsNew: false,
                WarehousedCount: 0,
                OrderWaitOutQuantity: 0,
                POrderWaitInQuantity: 0,
                State: 0,
                // 是否可编辑，用于报价转销售情况时新增数据情况
                canEdit: false
            });

            this.priceChange();

            setTimeout(() => {
                this.$refs.infiniteTable.scrollToRow(this.dataList[this.dataList.length - 1]);
                this.$refs.infiniteTable.setActiveRow(this.dataList[this.dataList.length - 1]);
                if (this.dataList.length > 1) {
                    let ilEle = document.getElementsByClassName('business-content')[0];
                    ilEle.scrollTop = ilEle.scrollHeight;
                }
            }, 100);
        },
        // 解锁
        upLock(index) {
            this.$set(
                this.dataList,
                index,
                Object.assign({}, this.dataList[index], {
                    hasLock: !this.dataList[index].hasLock
                })
            );
        },
        // 点击展开下拉框
        focusHandle(isNew, index, type) {
            if (type === 'code' && !isNew) {
                setTimeout(() => {
                    this.$refs[`code${index}`].focus();
                }, 200);
            }
            if (type === 'partsNameSelect' && !isNew) {
                setTimeout(() => {
                    this.$refs[`partsNameSelect`].focus();
                }, 200);
            }
            if (type === 'autoSeriseSelect' && !isNew) {
                setTimeout(() => {
                    this.$refs[`autoSeriseSelect`].focus();
                }, 200);
            }
            if (type === 'unitSelect') {
                setTimeout(() => {
                    this.$refs[`unitSelect`].focus();
                }, 200);
            }
        },
        //添加页面缓存
        addPageChace() {
            this.removePageChace();
            this.$util.setLocalStorage('salesOrder', this.submitData);
            this.$util.setLocalStorage('salesOrder_dataList', this.dataList);
        },
        //清除页面缓存
        removePageChace() {
            this.$util.clearLocalStorage('salesOrder');
            this.$util.clearLocalStorage('salesOrder_dataList');
        },
        //从缓存中获取默认出仓仓库
        getdefaultWarehouses() {
            if (this.dataReadonly) return;
            return new Promise(resolve => {
                this.$util.GetEntpCache({CacheKey:'defaultOutWarehouses',CacheType:'1'},true).then(result => {
                    if (result) {
                        let data =JSON.parse(result)
                        let isexit = this.warehouseList.find(e => e.WarehouseId == data.WarehouseId);
                        if (!isexit) {
                            this.warehouseList.push({
                                WarehouseId: data.WarehouseId,
                                WarehouseName: data.WarehouseName,
                                Type: data.WarehouseType
                            });
                        }

                        this.$set(this.submitData, 'WarehouseId', data.WarehouseId);
                        this.$set(this.submitData, 'WarehouseName', data.WarehouseName);

                        this.warehouseType = data.WarehouseType;
                    }
                    resolve();
                });
            });
        },

        /**
         * 获取默认数据
         * ShipType 发货方式
         * PayType 结算方式
         * FullAddress 收货地址
         */
        getDefaultData() {
            this.$util
                .axiosGet({
                    url: '/api/EntpCustomers/GetCustOrderNewsData',
                    data: {
                        cid: this.submitData.EntpCusId,
                        type: '0',
                        EntpId: this.userMsg.EntpId
                    },
                    hideLoading: true
                })
                .then(res => {
                    let data = res.data;
                    if (data) {
                        this.submitData.ShipType = data.ShipType;
                        this.submitData.PayType = data.PayType;
                        this.submitData.FullAddress = data.FullAddress;

                        this.submitData.LogisticId = data.LogisticId;
                        this.submitData.LogisticName = data.LogisticName;
                        this.submitData.LogisticItem = data.LogisticName;
                    }
                });
        },
        // 搜索汽配编码
        searchCode(key) {
            // 取消请求
            if (this.apcodeSource) {
                this.apcodeSource.cancel();
            }
            if (![undefined].includes(key)) {
                this.codeForm.Page = 1;
                this.codeForm.stopLoad = false;
                this.codeForm.key = key;
                this.codeList = [];
            }
            if (this.codeForm.stopLoad) return;
            // 初始化对象
            this.apcodeSource = this.axios.CancelToken.source();

            this.loading = true;
            this.$util
                .axiosGet({
                    url: '/api/EntpGoods/GetGoodsSelItemsForSaleOrder',
                    data: {
                        APCode: this.codeForm.key,
                        Page: this.codeForm.Page,
                        Limit: this.codeForm.Limit,
                        EntpId: this.userMsg.EntpId,
                        SId: this.submitData.WarehouseId,
                        CId: this.submitData.EntpCusId,
                        SFrom:'apc'
                    },
                    hideLoading: true,
                    cancelToken: this.apcodeSource.token // 取消操作标识
                })
                .then(res => {
                    this.loading = false;
                    if (!res.data) return;
                    this.codeForm.stopLoad = res.data.length < this.codeForm.Limit;
                    this.codeList = this.$util.uniqueArr(this.codeList, res.data);
                });
        },
        // 汽配编码列表，加载更多
        searchCodeLoad() {
            if (!this.loading) {
                this.codeForm.Page += 1;
                this.searchCode();
            }
        },
        // 搜索名称
        searchName(key, item) {
            if (![undefined].includes(key)) {
                this.nameForm.Page = 1;
                this.nameForm.stopLoad = false;
                this.nameForm.key = key;
                this.nameList = [];
            }
            if (this.nameForm.stopLoad) return;
            this.loading = true;
            this.$util
                .axiosGet({
                    url: '/api/EntpGoods/GetGoodsSelItemsForSaleOrder',
                    data: {
                        GoodName: this.nameForm.key,
                        Page: this.nameForm.Page,
                        Limit: this.nameForm.Limit,
                        EntpId: this.userMsg.EntpId,
                        SId: this.submitData.WarehouseId,
                        CId: this.submitData.EntpCusId,
                        SFrom:'gn'
                    },
                    hideLoading: true
                })
                .then(res => {
                    this.loading = false;
                    if (!res.data) return;
                    this.nameForm.stopLoad = Array.isArray(res.data) && res.data.length < this.nameForm.Limit;
                    this.nameList = this.$util.uniqueArr(this.nameList, res.data);
                    if (item) {
                        item.VGoodName = key;
                        item.GoodName = key;
                        this.seriesList = res.data;
                    }
                });
        },
        // 汽配名称列表，加载更多
        searchNameLoad() {
            this.nameForm.Page += 1;
            this.searchName();
        },
        // 搜车系
        searchAutoSerie(key, item) {
            if (![undefined].includes(key)) {
                this.autoSerieForm.Page = 1;
                this.autoSerieForm.stopLoad = false;
                this.autoSerieForm.key = key;
                this.seriesList = [];
            }
            if (this.autoSerieForm.stopLoad) return;
            this.loading = true;
            this.$util
                .axiosGet({
                    url: '/api/EntpGoods/GetGoodsSelItemsForSaleOrder',
                    data: {
                        GoodName: item ? item.VGoodName : '', //配合商品名称查
                        Page: this.autoSerieForm.Page,
                        Limit: this.autoSerieForm.Limit,
                        EntpId: this.userMsg.EntpId,
                        SId: this.submitData.WarehouseId,
                        CId: this.submitData.EntpCusId,
                        OnlySeries: true,
                        SeriesName: this.autoSerieForm.key, 
                        SFrom:'sn'
                    },
                    hideLoading: true
                })
                .then(res => {
                    this.loading = false;
                    if (!res.data) return;
                    this.autoSerieForm.stopLoad = res.data.length < this.autoSerieForm.Limit;
                    this.seriesList = this.$util.uniqueArr(this.seriesList, res.data);
                });
        },
        // 车系列表，加载更多
        searchAutoSerieLoad() {
            this.autoSerieForm.Page += 1;
            this.searchAutoSerie();
        },
        //结算方式
        getPay() {
            this.$util.getPay().then(data => {
                this.payWayList = data;
            });
        },
        // 获取发货方式
        getSendWay() {
            this.$util.getSendWay().then(data => {
                this.DeliveryMethodList = data;
            });
        },
        //检查是否亏本
        CheckLoseMoney(costPrice, salePric) {
            let that = this;
            if (!that.LoseMoneyValue || !costPrice || !salePric) return false;

            let val = Number(salePric) * ((100 - that.LoseMoneyValue) / 100) < Number(costPrice);
            return val;
        },
        // 名称改变
        nameChange(item, index) {
            if (!item) {
                this.dataList[index].VGoodName = '';
                this.dataList[index].GoodName = '';
            } else if (typeof item == 'string') {
                this.dataList[index].VGoodName = item;
                this.dataList[index].GoodName = item;
            } else {
                if (!this.dataList[index].APCode) {
                    this.dataList[index].APCode = item.APCode;
                    this.dataList[index].EntpTempGoodsId = item.EntpTempGoodsId;
                    this.dataList[index].State = 0;
                }
                this.dataList[index].CostPrice = item.CostPrice;
                this.dataList[index].GoodName = item.GoodName;
                this.dataList[index].VGoodName = item.GoodName;
                this.dataList[index].Unit = item.Unit;
                this.dataList[index].AutoSerise = item.AutoSerise;
                this.dataList[index].AutoSeriseItem = item.AutoSerise;
                this.dataList[index].Inventory = item.Inventory;
                this.dataList[index].StorageInventory = item.StorageInventory;
                this.dataList[index].ReferencePrice = item.ReferencePrice;
                this.dataList[index].MarketPrice = item.LatestPrice > 0 ? item.LatestPrice : '';

                this.dataList[index].OrderWaitOutQuantity = item.OrderWaitOutQuantity;
                this.dataList[index].POrderWaitInQuantity = item.POrderWaitInQuantity;
                this.dataList[index].LatestSalesTime = item.LatestSalesTime;

                this.$util.getGoodsDataAfterSelItem(this.dataList[index].EntpTempGoodsId, this.submitData.WarehouseId, this.submitData.EntpCusId).then(data => {
                    if (data) {
                        this.dataList[index].OrderWaitOutQuantity = data.OrderWaitOutQuantity;
                        this.dataList[index].POrderWaitInQuantity = data.POrderWaitInQuantity;
                        this.dataList[index].StorageInventory = data.StorageInventory;
                        this.dataList[index].LatestSalesTime = data.LatestSalesTime;
                        this.dataList[index].MarketPrice = data.LatestPrice > 0 ? data.LatestPrice : '';
                        if (data.ReferencePrice) this.dataList[index].ReferencePrice = data.ReferencePrice;
                    }
                });
            }

            this.priceChange();
        },
        // 编码改变
        codeChange(value, index) {
            let isNew = true;
            let _list = this.codeList;
            if (!value) {
                this.dataList[index].IsNew = false;
            }
            for (let i = 0; i < _list.length; i++) {
                if (_list[i].APCode == value) {
                    this.dataList[index].OrderWaitOutQuantity = _list[i].OrderWaitOutQuantity;
                    this.dataList[index].POrderWaitInQuantity = _list[i].POrderWaitInQuantity;
                    this.dataList[index].APCode = _list[i].APCode;
                    this.dataList[index].CostPrice = _list[i].CostPrice;
                    this.dataList[index].EntpTempGoodsId = _list[i].EntpTempGoodsId;
                    this.dataList[index].GoodName = _list[i].GoodName;
                    this.dataList[index].GoodNameItem = _list[i].GoodName;
                    this.dataList[index].Unit = _list[i].Unit;
                    this.dataList[index].AutoSerise = _list[i].AutoSerise;
                    this.dataList[index].AutoSeriseItem = _list[i].AutoSerise;
                    this.dataList[index].Inventory = _list[i].Inventory;
                    this.dataList[index].StorageInventory = _list[i].StorageInventory;
                    this.dataList[index].ReferencePrice = _list[i].ReferencePrice;
                    this.dataList[index].MarketPrice = _list[i].LatestPrice > 0 ? _list[i].LatestPrice : '';
                    this.dataList[index].State = 0;
                    isNew = false;
                    this.$util.getGoodsDataAfterSelItem(this.dataList[index].EntpTempGoodsId, this.submitData.WarehouseId, this.submitData.EntpCusId).then(data => {
                        if (data) {
                            this.dataList[index].OrderWaitOutQuantity = data.OrderWaitOutQuantity;
                            this.dataList[index].POrderWaitInQuantity = data.POrderWaitInQuantity;
                            this.dataList[index].StorageInventory = data.StorageInventory;
                            this.dataList[index].LatestSalesTime = data.LatestSalesTime;
                            this.dataList[index].MarketPrice = data.LatestPrice > 0 ? data.LatestPrice : '';
                            if (data.ReferencePrice) this.dataList[index].ReferencePrice = data.ReferencePrice;
                        }
                    });
                    break;
                }
            }
            if (isNew && value) {
                let that = this;
                this.$util.elConfirm({
                    content: '要创建一个新配件吗？',
                    noMsg: true,
                    confirm() {
                        that.dataList[index].EntpTempGoodsId = '';
                        that.dataList[index].Inventory = 0;
                        that.dataList[index].StorageInventory = 0;
                        that.dataList[index].MarketPrice = '';
                        that.dataList[index].ReferencePrice = 0;
                        that.dataList[index].State = 0;
                        that.dataList[index].IsNew = true;
                        that.$refs.infiniteTable.setActiveRow(that.dataList[index]);
                        that.$util
                            .axiosGet({
                                url: '/api/EntpGoods/GetPart',
                                data: {
                                    APCode: value
                                },
                                hideLoading: true
                            })
                            .then(res => {
                                if (res.data) {
                                    let data = res.data;
                                    that.dataList[index].APCode = data.APCode;
                                    that.dataList[index].AutoSerise = data.AutoSerise;
                                    that.dataList[index].AutoSeriseItem = data.AutoSerise;
                                    that.dataList[index].GoodName = data.GoodName;
                                    that.dataList[index].GoodNameItem = data.GoodName;
                                    that.dataList[index].Unit = data.Unit;
                                }
                            });
                    }
                });
            }
            this.priceChange();
        },

        //车型改变 AutoSeriseItem值仅仅用于选中值为对象的效果，实际上保存的数据还是AutoSerise
        seriseChange(item, index) {
            if (!item) {
                this.dataList[index].AutoSerise = '';
            } else if (typeof item == 'string') {
                this.dataList[index].AutoSerise = item;
            } else {
                this.dataList[index].APCode = item.APCode;
                this.dataList[index].EntpTempGoodsId = item.EntpTempGoodsId;
                this.dataList[index].State = 0;
                this.dataList[index].CostPrice = item.CostPrice;
                this.dataList[index].GoodName = item.GoodName;
                this.dataList[index].VGoodName = item.GoodName;
                this.dataList[index].Unit = item.Unit;
                this.dataList[index].AutoSerise = item.AutoSerise;
                this.dataList[index].Inventory = item.Inventory;
                this.dataList[index].StorageInventory = item.StorageInventory;
                this.dataList[index].ReferencePrice = item.ReferencePrice;
                this.dataList[index].MarketPrice = item.LatestPrice > 0 ? item.LatestPrice : '';
                this.dataList[index].OrderWaitOutQuantity = item.OrderWaitOutQuantity;
                this.dataList[index].POrderWaitInQuantity = item.POrderWaitInQuantity;
                this.dataList[index].LatestSalesTime = item.LatestSalesTime;
                this.$util.getGoodsDataAfterSelItem(this.dataList[index].EntpTempGoodsId, this.submitData.WarehouseId, this.submitData.EntpCusId).then(data => {
                    if (data) {
                        this.dataList[index].OrderWaitOutQuantity = data.OrderWaitOutQuantity;
                        this.dataList[index].POrderWaitInQuantity = data.POrderWaitInQuantity;
                        this.dataList[index].StorageInventory = data.StorageInventory;
                        this.dataList[index].LatestSalesTime = data.LatestSalesTime;
                        this.dataList[index].MarketPrice = data.LatestPrice > 0 ? data.LatestPrice : '';
                        if (data.ReferencePrice) this.dataList[index].ReferencePrice = data.ReferencePrice;
                    }
                });
                this.priceChange();
            }
        },
        //查地址列表
        querySearch(queryString, cb) {
            var restaurants = this.addressList;
            cb(restaurants);
        },
        //业务员改变
        sIdChange(value) {
            let _list = this.SIdList;
            for (let i = 0; i < _list.length; i++) {
                if (_list[i].EmployeeId == value) {
                    this.submitData.SName = _list[i].EmployeeName;
                    return;
                }
            }
        },
        //跟单采购员的改变
        followerChange(value) {
            let _list = this.FollowerList;
            for (let i = 0; i < _list.length; i++) {
                if (_list[i].EmployeeId == value) {
                    this.submitData.FollowerName = _list[i].EmployeeName;
                    return;
                }
            }
        },
        //单位下拉框显示时触发event
        unitVisibleChange(event) {
            let that = this;
            if (event) {
                if (that.unitList.length == 0) that.getConfigData();
            }
        },
        //当汽配件编码下拉框出现时触发
        apCodeVisibleChange(event) {
            let that = this;
            if (event && that.codeList.length == 0 && that.isPreloadApCodeList) {
                that.searchCode('');
            }
        },
        //当汽配件名称下拉框出现时触发
        apNameVisibleChange(event) {
            let that = this;
            if (event && that.nameList.length == 0 && that.isPreloadApCodeList) {
                that.searchName('');
            }
        },
        //当车系下拉框出现时触发
        autoSeriseVisibleChange(event, item) {
            let that = this;
            if (event && that.seriesList.length == 0 && that.isPreloadApCodeList) {
                that.searchAutoSerie('', item);
            }
        },
        //当业务员下拉框出现时触发
        siVisibleChange(event) {
            let that = this;
            if (event) {
                that.getSIdList();
            }
        },
        // 获取仓库列表
        getWarehouse() {
            this.$util.getWarehouse(1).then(data => {
                this.warehouseList = data;
            });
        },
        warehouseVisibleChange(event) {
            let that = this;
            if (event) {
                if (that.warehouseList.length <= 1) that.getWarehouse();
            }
        },
        warehouseChange(val) {
            let that = this;
            if (!val) {
                that.submitData.WarehouseName = '';
                that.dataList.forEach((e, i) => {
                    e.StorageInventory = 0;
                });
            } else {
                for (let i = 0; i < that.warehouseList.length; i++) {
                    if (val == that.warehouseList[i].WarehouseId) {
                        that.submitData.WarehouseName = that.warehouseList[i].WarehouseName;
                        that.warehouseType = that.warehouseList[i].Type;
                        break;
                    }
                }
                // 查询在这个仓库下的商品库存
                if (that.dataList) {
                    let ids = [];
                    that.dataList.forEach((e, i) => {
                        if (e.EntpTempGoodsId) ids.push(e.EntpTempGoodsId);
                    });
                    if (ids.length > 0) {
                        that.$util
                            .axiosPost({
                                url: '/api/EntpSaleOrder/GetGoodsStoragesInventorys',
                                data: {
                                    sId: val,
                                    ids: ids
                                }
                            })
                            .then(res => {
                                let data = res.data;
                                that.dataList.forEach((e, i) => {
                                    let getStorage = data.find(d => d.GoodsId == e.EntpTempGoodsId);
                                    if (getStorage) {
                                        e.StorageInventory = getStorage.Count;
                                        e.OrderWaitOutQuantity = getStorage.OrderWaitOutQuantity;
                                        e.POrderWaitInQuantity = getStorage.POrderWaitInQuantity;
                                    } else {
                                        e.StorageInventory = 0;
                                        e.OrderWaitOutQuantity = 0;
                                        e.POrderWaitInQuantity = 0;
                                    }
                                });
                            })
                            .catch(() => {});
                    }
                }
            }
        },
        // 设置展示合计数据行
        setSummaries(param) {
            const { data } = param;
            let num = 0;
            let price = 0;
            data.forEach(ele => {
                num += Number(ele.Count);
                price += Number(ele.Count * ele.MarketPrice ? (ele.Count * ele.MarketPrice).toFixed(3) : 0);
            });
            return [['', '', '', '总数量', num, '', '', '销售商品总额', price.toFixed(2), '', '']];
        },
        // 设置展示行样式
        setRowStyle(param) {
            const { row, index } = param;
            let rowArr = this.dataList.filter(f => f.APCode === row.APCode);
            if (rowArr.length > 1) {
                return `background-color: #FFE8E8`;
            }
        },
        logisticVisibleChange(event) {
            let that = this;
            if (event) {
                if (that.logisticsList.length == 0) that.searchLogistic('');
            }
        },
        searchLogistic(key) {
            this.loading = true;
            this.$util
                .searchLogistic(key, 1, this.Limit)
                .then(data => {
                    this.logisticsList = data ? data : [];
                    this.loading = false;
                })
                .catch(() => {
                    this.loading = false;
                });
        },
        logisticChange(item) {
            if (!item) {
                this.submitData.LogisticName = '';
                this.submitData.LogisticId = '';
                this.submitData.LogisticItem = '';
            } else if (typeof item == 'string') {
                this.submitData.LogisticName = item;
                this.submitData.LogisticId = '';
            } else {
                this.submitData.LogisticName = item.EntpCusName;
                this.submitData.LogisticId = item.EntpCusId;
            }
        }
    }
};
</script>
<style lang="less" scoped>
.el-form-item {
    margin-bottom: 0px;
}
.payment-tip {
    position: absolute;
    left: 0;
    bottom: -18px;
    line-height: 1;
    font-size: 12px;
    color: @font4Color;
}
.form-main {
    display: flex;
    flex-direction: row;
    width: 100%;
    height: auto;
}
.form-bottom {
    width: 40%;
    float: left;
}
.form-uploadImg {
    margin-bottom: 20px;
}
.form-uploadImg div {
    width: 100%;
    font-size: 14px;
    margin-bottom: 10px;
}
.form-section {
    display: flex;
}
.section-title {
    display: flex;
    justify-content: space-between;
    height: 36px;
    line-height: 36px;
    padding: 0 20px;
    font-weight: bold;
    font-size: @font-sm;
    margin-left: -1px;
    background: @border3Color;
}
.edit-ctn {
    .div-table-cell {
        padding: 0 5px;
    }
}
.search-ctn {
    border: 1px solid @border3Color;
    padding-top: 10px;
    margin-bottom: 10px;
}
.option-content {
    display: flex;
    line-height: 30px;

    .project-Name {
        width: 200px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        margin-right: 12px;
    }
}
.btn-ctn {
    padding: 30px 0;
    margin-right: 110px;
    text-align: right;
}
.add-btn {
    position: absolute;
    right: 2%;
    bottom: 0;
}
.less-btn {
    position: absolute;
    right: -40px;
    top: 2px;
    z-index: 2;
}
.table-main {
    position: relative;
}
.image-btn {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 60px;
    height: 60px;
    border: 1px dashed @border3Color;
}
.table-title {
    line-height: 36px;
    text-align: center;
    font-weight: bold;
}
.div-table-cell {
    display: flex;
    align-items: center;
    justify-content: center;
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
    flex-grow: 1;
}
.table-item {
    height: 50px;
    position: relative;
}
.div-table-row {
    overflow: inherit;
    margin: -1px -1px -1px 0px;
}
.info-icon {
    vertical-align: top;
    margin-top: 2px;
    margin-right: 5px;
}
.special-border {
    height: 100%;
    border-radius: 3px;
    border: 1px solid #ffcc00;
}
.head-view {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    .color-red {
        margin-right: 4px;
    }
    .sort-view {
        display: flex;
        flex-direction: column;
        i {
            line-height: 8px;
            cursor: pointer;
        }
        .active {
            color: #409eff;
        }
    }
}
.saveProgress {
    position: absolute;
    top: 38%;
    left: 45%;
    z-index: 99999;
}
</style>

<style lang="less">
.check-code-class {
    .el-input__inner {
        border: 1px solid #f56c6c;
    }
}
.loseMoneyWarning {
    .el-input__inner {
        border: 1px solid #e6a23c;
    }
}
.el-col {
    border-radius: 4px;
}
.bg-purple-dark {
    background: #99a9bf;
}
.bg-purple {
    background: #d3dce6;
}
.bg-purple-light {
    background: #e5e9f2;
}
.grid-content {
    border-radius: 4px;
    min-height: 36px;
}
.row-bg {
    padding: 10px 0;
    background-color: #f9fafc;
}
.sales-order-edit {
    .el-row {
        margin-bottom: 10px;
        &:last-child {
            margin-bottom: 10px;
        }
    }
    .elx-table {
        .elx-table--body-wrapper {
            .elx-body--row {
                .table-sort {
                    .elx-cell {
                        padding: 4px 12px 0;
                    }
                }
                .div-padding-12 {
                    padding: 4px 8px 0;
                }
                .div-margin-op {
                    display: flex;
                    flex-direction: row;
                    align-items: center;
                }
                .operate {
                    padding: 0 12px;
                }
                td {
                    height: 26px;
                }
            }
            .elx-cell {
                padding: 0;
                height: 32px;
            }
            .el-button--small {
                padding: 5px 15px;
                margin: 3px 9px 0 0;
            }
        }
        .elx-table--footer-wrapper {
            margin-top: 0 !important;
            .elx-footer--row {
                .elx-footer--column {
                    height: 34px;
                }

                .elx-cell {
                    padding: 4px 12px 0;
                }
            }
        }
        .elx-table--body-wrapper {
            padding-bottom: 180px !important;
        }
    }
    .infinite-list-special-class {
        .elx-table {
            .elx-table--body-wrapper {
                padding-bottom: 0 !important;
            }
        }
    }
    .bottom-div {
        margin-top: 24px;
        .ship-amount {
            text-align: right;
            margin-bottom: 16px;
            .discount-count {
                font-size: 15px;
                font-weight: bold;
                color: #f00;
            }
        }
        .part {
            display: flex;
            flex-direction: row;
            justify-content: flex-end;
            align-items: center;
            flex-wrap: wrap;
            margin-bottom: 16px;
        }
        .no-fee {
            display: flex;
            flex-direction: row;
            justify-content: flex-end;
        }
        .subzone {
            .dismoney {
                display: flex;
                flex-direction: row;
                justify-content: center;
                align-items: center;
                height: 32px;
                .percent-view {
                    display: flex;
                    align-items: center;
                    span {
                        margin-left: 12px;
                    }
                }
                .el-input-number {
                    width: 110px;
                    .el-input__inner {
                        height: 32px;
                    }
                }
                .el-select {
                    margin-right: 12px;
                    .el-input__inner {
                        width: 110px;
                        height: 32px;
                        color: red;
                    }
                    .el-input__suffix {
                        top: 4px;
                    }
                    .is-focus {
                        .el-input__suffix {
                            top: -4px;
                        }
                    }
                }
            }
            .discount-count {
                font-size: 15px;
                font-weight: bold;
                color: #f00;
            }
        }
    }
    .sales-input-cell {
        .el-input-number {
            width: 100%;
        }
        .el-input {
            .el-input__inner {
                padding-left: 0;
                padding-right: 20px;
            }
        }
        .el-input-number__decrease,
        .el-input-number__increase {
            width: 20px;
        }
    }
    .unit-input-cell {
        .el-input {
            .el-input__inner {
                padding-right: 20px;
            }
        }
    }
    .sales-apcode {
        .el-tag {
            height: 24px;
            line-height: 22px;
            margin-left: 8px;
        }
    }
}
</style>
